import API from "./API";

export default class Formacoes extends API
{
    /*
     * =========================================================
     * FORMAÇÕES
     * =========================================================
     */

    static async search(params = {}) {
        const query = new URLSearchParams();

        Object.keys(params || {}).forEach((key) => {
            const value = params[key];

            if (value !== null && value !== undefined && value !== "") {
                query.append(key, value);
            }
        });

        const qs = query.toString();

        return super.get(
            "api/admin/formacoes" + (qs ? "?" + qs : "")
        );
    }

    static async get(id) {
        return super.get(
            "api/admin/formacoes/" + id
        );
    }

    static async getTiposFormacao() {
        return super.get(
            "api/admin/formacoes/get-tipos-formacao"
        );
    }

    static async create(params) {
        return super.post(
            "api/admin/formacoes",
            params
        );
    }

    static async update(id, params) {
        return super.put(
            "api/admin/formacoes/" + id,
            params
        );
    }

    static assinaturaParticipanteUrl(participanteId) {
        return process.env.VUE_APP_API_DOMAIN
            + "/api/admin/formacoes/participantes/"
            + participanteId
            + "/assinatura";
    }

    static async delete(id) {
        return super.delete(
            "api/admin/formacoes/" + id
        );
    }


    /*
     * =========================================================
     * FORMULÁRIOS DE FORMAÇÃO
     * =========================================================
     */

    static async searchFormularios(params = {}) {
        const query = new URLSearchParams();

        Object.keys(params || {}).forEach((key) => {
            const value = params[key];

            if (value !== null && value !== undefined && value !== "") {
                query.append(key, value);
            }
        });

        const qs = query.toString();

        return super.get(
            "api/admin/formacoes/formularios"
            + (qs ? "?" + qs : "")
        );
    }

    static async getFormulario(id) {
        return super.get(
            "api/admin/formacoes/formularios/" + id
        );
    }

    static async createFormulario(params) {
        return super.post(
            "api/admin/formacoes/formularios",
            params
        );
    }

    static async updateFormulario(id, params) {
        return super.put(
            "api/admin/formacoes/formularios/" + id,
            params
        );
    }

    static async deleteFormulario(id) {
        return super.delete(
            "api/admin/formacoes/formularios/" + id
        );
    }
}